import { Component, OnInit } from '@angular/core';
import { CompareService } from '../../compare/compare.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IProject } from '../project';
import { IWorkItem } from '../workItem';
import { IRepo } from '../repo';
import { IBuild } from '../build';

@Component({
  selector: 'app-select-builds',
  templateUrl: './select-builds.component.html',
  styleUrls: ['./select-builds.component.css']
})
export class SelectBuildsComponent implements OnInit {

  constructor(private data: CompareService, private router: Router, private fb: FormBuilder) { }

  public compareForm: FormGroup;
  public projects: IProject[];
  public workitems: IWorkItem[];
  public repos: IRepo[];
  public builds: IBuild[];

  ngOnInit() {

  }


}
